  <!-- TODO: {"status":"error","message":"no implicit conversion of Float into String"} -->
<template>
  <div>
    <v-row v-if="showSkeletonLoader">
      <v-col cols="12">
        <v-skeleton-loader type="table" />
      </v-col>
    </v-row>

    <template v-else>
      <v-row v-if="eodClosingUserAggregationsData && eodClosingUserAggregationsData.length">
        <v-col cols="6">
          <h2>ユーザー集計</h2>
        </v-col>
        <v-col
          cols="6"
          class="d-flex"
        >
          <v-spacer />
          <v-btn
            color="primary"
            :ripple="false"
            :disabled="!canEnqueueJobs.userAggregations"
            :loading="isAnyJobInProgress.userAggregations"
            @click="enqueueUserAggregations"
          >
            <v-icon left>
              {{ icons.mdiSync }}
            </v-icon>
            日計ジョブ一括実行
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        v-for="agg in eodClosingUserAggregationsData"
        :key="`aggregation-${agg.id}`"
      >
        <v-col cols="12">
          <v-skeleton-loader
            v-if="jobStatuses[agg.id] === 'in_progress'"
            type="table"
          />
          <template v-else-if="eodClosingUserAggregationsMap[agg.id]">
            <EodClosingAggregationTable
              :aggregation="eodClosingUserAggregationsMap[agg.id]"
              :loading="loadingStatuses[agg.id]"
              :aggregation-users="aggregationUsers(agg.id)"
              :available-users="availableUsers[agg.id]"
              :error-message="jobErrorMessages[agg.id]"
              :status="jobStatuses[agg.id]"
              @save-all="enqueueGenerateBusinessRuleResults"
              @save="generateBusinessRuleResult"
              @reload="reloadAggregation"
              @refresh="refreshAggregation"
              @create-user-aggregation="createEodClosingUserAggregation(agg.id, $event)"
              @destroy-user-aggregation="destroyEodClosingUserAggregation(agg.id, $event)"
              @fetch-available-users="handleFetchAvailableUsers(agg.id, $event)"
              @select-user="openUserPanel"
            />
            <p
              v-if="jobTimestamps[agg.id].createdAt && jobTimestamps[agg.id].updatedAt"
              class="text-xs secondary--text text-right"
            >
              <span class="mr-2">最終集計日時:</span>
              {{ showFormattedTimestamp(jobTimestamps[agg.id].updatedAt) }}
            </p>
          </template>
          <AggregationEmptyTable
            v-else
            :id="agg.id"
            :name="agg.attributes.name"
          >
            <template #toolbar-addons>
              <v-btn
                :ripple="false"
                :loading="loadingStatuses[agg.id]"
                :disabled="loadingStatuses[agg.id]"
                color="secondary"
                small
                @click="reloadAggregation(agg.id)"
              >
                <v-icon left>
                  {{ icons.mdiReload }}
                </v-icon>
                個別実行
              </v-btn>
            </template>
          </AggregationEmptyTable>
        </v-col>
      </v-row>

      <v-row v-if="eodClosingTableAggregationsData && eodClosingTableAggregationsData.length">
        <v-col cols="6">
          <h2>卓集計</h2>
        </v-col>
        <v-col
          cols="6"
          class="d-flex"
        >
          <v-spacer />
          <v-btn
            color="primary"
            :ripple="false"
            :disabled="!canEnqueueJobs.tableAggregations"
            :loading="isAnyJobInProgress.tableAggregations"
            @click="enqueueTableAggregations"
          >
            <v-icon left>
              {{ icons.mdiSync }}
            </v-icon>
            日計ジョブ一括実行
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        v-for="agg in eodClosingTableAggregationsData"
        :key="`aggregation-${agg.id}`"
      >
        <v-col cols="12">
          <v-skeleton-loader
            v-if="jobStatuses[agg.id] === 'in_progress'"
            type="table-heading, list-item-two-line"
          />
          <template v-else-if="eodClosingTableAggregationsMap[agg.id]">
            <EodClosingAggregationTable
              :aggregation="eodClosingTableAggregationsMap[agg.id]"
              :loading="loadingStatuses[agg.id]"
              :error-message="jobErrorMessages[agg.id]"
              :status="jobStatuses[agg.id]"
              @save-all="enqueueGenerateBusinessRuleResults"
              @save="generateBusinessRuleResult"
              @reload="reloadAggregation"
              @refresh="refreshAggregation"
            />
            <p
              v-if="jobTimestamps[agg.id].createdAt && jobTimestamps[agg.id].updatedAt"
              class="text-xs secondary--text text-right"
            >
              <span class="mr-2">最終集計日時:</span>
              {{ showFormattedTimestamp(jobTimestamps[agg.id].updatedAt) }}
            </p>
          </template>
          <AggregationEmptyTable
            v-else
            :id="agg.id"
            :name="agg.attributes.name"
          >
            <template #toolbar-addons>
              <v-btn
                :ripple="false"
                :loading="loadingStatuses[agg.id]"
                :disabled="loadingStatuses[agg.id]"
                color="secondary"
                small
                @click="reloadAggregation(agg.id)"
              >
                <v-icon left>
                  {{ icons.mdiReload }}
                </v-icon>
                個別実行
              </v-btn>
            </template>
          </AggregationEmptyTable>
        </v-col>
      </v-row>

      <v-row v-if="eodClosingClubAggregationsData && eodClosingClubAggregationsData.length">
        <v-col cols="6">
          <h2>店舗集計</h2>
        </v-col>
        <v-col
          cols="6"
          class="d-flex"
        >
          <v-spacer />
          <v-btn
            color="primary"
            :ripple="false"
            :disabled="!canEnqueueJobs.clubAggregations"
            :loading="isAnyJobInProgress.clubAggregations"
            @click="enqueueClubAggregations"
          >
            <v-icon left>
              {{ icons.mdiSync }}
            </v-icon>
            日計ジョブ一括実行
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        v-for="agg in eodClosingClubAggregationsData"
        :key="`aggregation-${agg.id}`"
      >
        <v-col cols="12">
          <v-skeleton-loader
            v-if="jobStatuses[agg.id] === 'in_progress'"
            type="table-heading, list-item-two-line"
          />
          <template v-else-if="eodClosingClubAggregationsMap[agg.id]">
            <EodClosingAggregationTable
              :aggregation="eodClosingClubAggregationsMap[agg.id]"
              :loading="loadingStatuses[agg.id]"
              :error-message="jobErrorMessages[agg.id]"
              :status="jobStatuses[agg.id]"
              @save-all="enqueueGenerateBusinessRuleResults"
              @save="generateBusinessRuleResult"
              @reload="reloadAggregation"
              @refresh="refreshAggregation"
            />
            <p
              v-if="jobTimestamps[agg.id].createdAt && jobTimestamps[agg.id].updatedAt"
              class="text-xs secondary--text text-right"
            >
              <span class="mr-2">最終集計日時:</span>
              {{ showFormattedTimestamp(jobTimestamps[agg.id].updatedAt) }}
            </p>
          </template>
          <AggregationEmptyTable
            v-else
            :id="agg.id"
            :name="agg.attributes.name"
          >
            <template #toolbar-addons>
              <v-btn
                :ripple="false"
                :loading="loadingStatuses[agg.id]"
                :disabled="loadingStatuses[agg.id]"
                color="secondary"
                small
                @click="reloadAggregation(agg.id)"
              >
                <v-icon left>
                  {{ icons.mdiReload }}
                </v-icon>
                個別実行
              </v-btn>
            </template>
          </AggregationEmptyTable>
        </v-col>
      </v-row>
    </template>

    <UserPerformancePanel
      v-model="isPanelOpen"
      :date="date"
      :user-id="selectedUser ? selectedUser.userId : null"
      :user-name="selectedUser ? selectedUser.userName : ''"
      :items="selectedUserSummary.items"
      :total-count="selectedUserSummary.totalCount"
      :total-price="selectedUserSummary.totalPrice"
      :working-minutes="selectedUserSummary.workingMinutes"
      :is-loading="isPerformanceLoading"
      @timecard-saved="onTimecardSaved"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import {
  ref,
  reactive,
  computed,
  toRefs,
  watch,
  onMounted,
  getCurrentInstance,
} from '@vue/composition-api'
import { mdiSync, mdiReload } from '@mdi/js'
import { parseISO, format } from 'date-fns'
import AggregationApi from '@/api/v2/eod-closing/Aggregation'
import AggregationUserApi from '@/api/v2/eod-closing/AggregationUser'
import BusinessRuleApi from '@/api/v2/eod-closing/BusinessRule'
import useAggregation from '../composables/useAggregation'
import useUserPerformanceSummaries from '../composables/useUserPerformanceSummaries'
import EodClosingAggregationTable from './AggregationTable.vue'
import AggregationEmptyTable from './AggregationEmptyTable.vue'
import UserPerformancePanel from './UserPerformancePanel.vue'
import { handleApiError } from '@/utils/errorHandler'

export default {
  components: {
    EodClosingAggregationTable,
    AggregationEmptyTable,
    UserPerformancePanel,
  },
  props: {
    date: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const vm = getCurrentInstance().proxy

    const { date } = toRefs(props)

    const isLoading = ref(true)
    const aggregations = ref([])
    const aggregationsData = ref([])
    const loadingStatuses = reactive({})
    const jobTimestamps = reactive({})
    const jobErrorMessages = reactive({})
    const jobStatuses = ref({})
    const availableUsers = ref({})

    const {
      aggregationResultsMap,
      updateAggregationResult,
      sortAndFilterAggregationType,
      buildAggregationMap,
    } = useAggregation(aggregations)

    const {
      isLoading: isPerformanceLoading,
      fetch: fetchPerformanceSummaries,
      summaryForUser,
      clearCache: clearPerformanceCache,
      invalidateUser: invalidatePerformanceUser,
    } = useUserPerformanceSummaries()

    // ユーザー名クリック時の都度フェッチ（案1）。エラーはトースト表示のみで握りつぶさない。
    const fetchPerformanceForUser = (targetDate, userId) => {
      if (!targetDate || !userId) return
      fetchPerformanceSummaries(targetDate, userId).catch(error => {
        handleApiError(error, { $toast: vm.$toast })
      })
    }

    // 親(index.vue)から呼び出し可能なキャッシュ無効化メソッド。
    // ステッパー(データセット管理→経費→日計)の遷移で日計タブが表示されたタイミング等に使用する想定。
    const refreshUserPerformanceSummaries = () => {
      clearPerformanceCache()
    }

    // 日計画面の日付が変わった場合はキャッシュをクリア（次回クリック時に最新を取り直す）。
    // composable 内部でも日付変更検知して全クリアするが、念のため明示。
    watch(date, () => {
      clearPerformanceCache()
    })

    // 集計ジョブ完了時にキャッシュクリア。
    // 「再集計」「日計ジョブ一括実行」を押した結果、販売履歴ベースの集計値も最新化されるため、
    // ユーザー別実績パネルのキャッシュも次回クリック時に最新化されるようクリアする。
    watch(jobStatuses, (newStatuses, oldStatuses) => {
      if (!oldStatuses) return
      const completedNow = Object.keys(newStatuses).some(id => (
        newStatuses[id] === 'completed' && oldStatuses[id] !== 'completed'
      ))
      if (completedNow) clearPerformanceCache()
    }, { deep: true })

    // ユーザー別 受領商品集計パネル
    const selectedUser = ref(null)
    const isPanelOpen = ref(false)

    const selectedUserSummary = computed(() => {
      if (!selectedUser.value) {
        return {
          items: [], totalCount: 0, totalPrice: 0, workingMinutes: 0,
        }
      }

      return summaryForUser(selectedUser.value.userId)
    })

    const openUserPanel = payload => {
      selectedUser.value = payload
      isPanelOpen.value = true
      // 都度フェッチ: 未取得ユーザーなら API、取得済みなら composable 側で即時 return
      fetchPerformanceForUser(date.value, payload.userId)
    }

    // パネル内で勤務時間(タイムカード)が保存されたら、該当ユーザーのキャッシュを破棄して
    // 労働時間を再取得する
    const onTimecardSaved = () => {
      if (!selectedUser.value) return
      invalidatePerformanceUser(selectedUser.value.userId)
      fetchPerformanceForUser(date.value, selectedUser.value.userId)
    }

    const showSkeletonLoader = computed(() => isLoading.value || !date.value)

    const eodClosingUserAggregationsData = computed(() => sortAndFilterAggregationType(aggregationsData.value, 'EodClosingUserAggregation'))
    const eodClosingClubAggregationsData = computed(() => sortAndFilterAggregationType(aggregationsData.value, 'EodClosingClubAggregation'))
    const eodClosingTableAggregationsData = computed(() => sortAndFilterAggregationType(aggregationsData.value, 'EodClosingTableAggregation'))
    const eodClosingUserAggregationsMap = computed(() => buildAggregationMap(sortAndFilterAggregationType(aggregations.value, 'EodClosingUserAggregation')))
    const eodClosingClubAggregationsMap = computed(() => buildAggregationMap(sortAndFilterAggregationType(aggregations.value, 'EodClosingClubAggregation')))
    const eodClosingTableAggregationsMap = computed(() => buildAggregationMap(sortAndFilterAggregationType(aggregations.value, 'EodClosingTableAggregation')))
    const isAnyJobInProgress = computed(() => {
      return {
        userAggregations: eodClosingUserAggregationsData.value.some(agg => jobStatuses.value[agg.id] === 'in_progress'),
        clubAggregations: eodClosingClubAggregationsData.value.some(agg => jobStatuses.value[agg.id] === 'in_progress'),
        tableAggregations: eodClosingTableAggregationsData.value.some(agg => jobStatuses.value[agg.id] === 'in_progress'),
      }
    })
    const isAllJobCompleted = computed(() => {
      return {
        userAggregations: eodClosingUserAggregationsData.value.every(agg => jobStatuses.value[agg.id] === 'completed'),
        clubAggregations: eodClosingClubAggregationsData.value.every(agg => jobStatuses.value[agg.id] === 'completed'),
        tableAggregations: eodClosingTableAggregationsData.value.every(agg => jobStatuses.value[agg.id] === 'completed'),
      }
    })
    const isAnyJobMissing = computed(() => {
      return {
        userAggregations: eodClosingUserAggregationsData.value.some(agg => jobStatuses.value[agg.id] === 'failed' || jobStatuses.value[agg.id] === null),
        clubAggregations: eodClosingClubAggregationsData.value.some(agg => jobStatuses.value[agg.id] === 'failed' || jobStatuses.value[agg.id] === null),
        tableAggregations: eodClosingTableAggregationsData.value.some(agg => jobStatuses.value[agg.id] === 'failed' || jobStatuses.value[agg.id] === null),
      }
    })
    const isAllJobMissing = computed(() => {
      return {
        userAggregations: eodClosingUserAggregationsData.value.every(agg => jobStatuses.value[agg.id] === 'failed' || jobStatuses.value[agg.id] === null),
        clubAggregations: eodClosingClubAggregationsData.value.every(agg => jobStatuses.value[agg.id] === 'failed' || jobStatuses.value[agg.id] === null),
        tableAggregations: eodClosingTableAggregationsData.value.every(agg => jobStatuses.value[agg.id] === 'failed' || jobStatuses.value[agg.id] === null),
      }
    })
    const canEnqueueJobs = computed(() => {
      return {
        userAggregations: isAllJobMissing.value.userAggregations && !isAllJobCompleted.value.userAggregations && !isAnyJobInProgress.value.userAggregations,
        clubAggregations: isAllJobMissing.value.clubAggregations && !isAllJobCompleted.value.clubAggregations && !isAnyJobInProgress.value.clubAggregations,
        tableAggregations: isAllJobMissing.value.tableAggregations && !isAllJobCompleted.value.tableAggregations && !isAnyJobInProgress.value.tableAggregations,
      }
    })

    const aggregationUsers = computed(() => id => {
      const agg = aggregationsData.value.find(ag => ag.attributes.id === Number(id))
      if (agg?.attributes?.type === 'EodClosingUserAggregation') {
        return agg.attributes.aggregationUsers.data
      }

      return []
    })

    const showFormattedTimestamp = timestampStr => {
      if (!timestampStr) return ''

      return format(parseISO(timestampStr), 'yyyy/MM/dd HH:mm')
    }

    const upsertAggregation = data => {
      if (!data || !data.attributes) return

      const idx = aggregations.value.findIndex(ag => ag.attributes.id === data.attributes.id)

      if (idx >= 0) {
        aggregations.value.splice(idx, 1, data)
      } else {
        aggregations.value.push(data)
      }
    }

    const getAggregationJobStatus = async id => {
      try {
        const res = await AggregationApi.getAggregationJobStatus(id, date.value)
        if (res.data.status === 'success') {
          const {
            status, result, meta, errorMessage,
          } = res.data.data
          jobStatuses.value = { ...jobStatuses.value, [id]: status }
          jobErrorMessages[id] = errorMessage
          jobTimestamps[id] = { createdAt: meta.createdAt, updatedAt: meta.updatedAt }
          if (result && result.data) upsertAggregation(result.data)
        }
      } catch (error) {
        if (error.response?.status === 404) {
          jobStatuses.value = { ...jobStatuses.value, [id]: null }
        } else {
          handleApiError(error, { $toast: vm.$toast })
        }
      }
    }

    const pollAggregationJobStatus = async id => {
      let intervalTime = 5000 // 初期間隔 5 秒
      const interval = setInterval(async () => {
        try {
          await getAggregationJobStatus(id)
          if (['completed', 'failed', null].includes(jobStatuses.value[id])) {
            clearInterval(interval)
          }
        } catch (error) {
          clearInterval(interval)
          if (error.response?.status !== 404) {
            handleApiError(error, { $toast: vm.$toast })
          }
        }
        intervalTime = Math.min(intervalTime * 2, 60000) // 最大1分まで増加
      }, intervalTime)
    }

    const enqueueAggregation = async (id, options = {}) => {
      const { forceReload = false, forceRefresh = false } = options
      try {
        const res = await AggregationApi.enqueueAggregation(id, date.value, { forceReload, forceRefresh })
        if (res.status === 202) {
          jobStatuses.value = { ...jobStatuses.value, [id]: 'in_progress' }
          pollAggregationJobStatus(id)
        }
      } catch (error) {
        if (error.response?.status === 404) {
          jobStatuses.value = { ...jobStatuses.value, [id]: null }
        } else {
          handleApiError(error, { $toast: vm.$toast })
        }
      }
    }

    // 初期化時
    const getAggregations = async () => {
      isLoading.value = true
      try {
        const res = await AggregationApi.getAggregations(date.value)
        if (res.data.status === 'success') {
          const { data } = res.data.data
          aggregationsData.value = data
          const aggregationIds = []
          data.forEach(async ag => {
            Vue.set(loadingStatuses, ag.attributes.id, false)
            Vue.set(jobTimestamps, ag.attributes.id, { createdAt: null, updatedAt: null })
            Vue.set(jobErrorMessages, ag.attributes.id, null)
            // 初期化時はステータスをnullに設定（ジョブが存在しない状態）
            jobStatuses.value = { ...jobStatuses.value, [ag.attributes.id]: null }
            availableUsers.value = { ...availableUsers.value, [ag.attributes.id]: [] }
            aggregationIds.push(ag.attributes.id)
          })
          // jobステータス確認
          await Promise.all(aggregationIds.map(id => getAggregationJobStatus(id)))
        }
      } catch (error) {
        handleApiError(error, { $toast: vm.$toast })
      } finally {
        isLoading.value = false
      }
    }

    // 保存結果以外を再計算
    const reloadAggregation = id => {
      enqueueAggregation(id, { forceReload: true })
    }

    // 保存結果を削除してすべてを再計算
    const refreshAggregation = id => {
      enqueueAggregation(id, { forceReload: true, forceRefresh: true })
    }

    // 一括保存（手動で値を変更しての保存はないので依存関係は気にしなくていい）
    const enqueueGenerateBusinessRuleResults = async (id, options = {}) => {
      const { forceReload = false, forceRefresh = false } = options
      try {
        const res = await BusinessRuleApi.enqueueGenerateBusinessRuleResults(id, date.value, { forceReload, forceRefresh })
        if (res.status === 202) {
          jobStatuses.value = { ...jobStatuses.value, [id]: 'in_progress' }
          pollAggregationJobStatus(id)
        }
      } catch (error) {
        if (error.response?.status === 404) {
          jobStatuses.value = { ...jobStatuses.value, [id]: null }
        } else {
          handleApiError(error, { $toast: vm.$toast })
        }
      }
    }

    // TODO: 依存関係の処理はサーバ側でいい（getUserDependentsとかいらない）
    const generateBusinessRuleResult = async ({
      aggregationId,
      contextType,
      contextId,
      businessRuleId,
      resultValue,
    }) => {
      if (contextType !== 'Club' && !contextId) throw new TypeError('You need to specify contextId')

      Object.keys(loadingStatuses).forEach(id => { loadingStatuses[id] = true })
      try {
        const res = await BusinessRuleApi.generateBusinessRuleResult({
          aggregationId,
          contextType,
          contextId,
          businessRuleId,
          resultValue,
          date: date.value,
        })
        if (res.data.status === 'success') {
          res.data.data.data.forEach(businessRuleResult => updateAggregationResult(businessRuleResult))
        }
      } catch (error) {
        handleApiError(error, { $toast: vm.$toast })
      } finally {
        Object.keys(loadingStatuses).forEach(id => { loadingStatuses[id] = false })
      }
    }

    const createEodClosingUserAggregation = async (
      id,
      { userId, callback } = { userId: null, callback: () => {} },
    ) => {
      try {
        const res = await AggregationUserApi.createAggregationUser(id, userId)
        if (res.data.status === 'success') {
          const { data } = res.data.data
          const aggIdx = aggregationsData.value.findIndex(ag => ag.attributes.id === Number(id))
          if (aggIdx < 0) return

          const updatedAggData = { ...aggregationsData.value[aggIdx] }
          updatedAggData.attributes.aggregationUsers.data.push(data)
          aggregationsData.value.splice(aggIdx, 1, updatedAggData)

          const updatedAvailableUsers = availableUsers.value[id] ? [...availableUsers.value[id]] : []
          const userIdx = updatedAvailableUsers.findIndex(user => user.attributes.id === Number(userId))
          if (userIdx < 0) return

          updatedAvailableUsers.splice(userIdx, 1)
          availableUsers.value = { ...availableUsers.value, [id]: updatedAvailableUsers }
        }
      } catch (error) {
        handleApiError(error, { $toast: vm.$toast })
      } finally {
        callback()
      }
    }

    const destroyEodClosingUserAggregation = async (
      aggregationId,
      { id, userId, callback } = { id: null, userId: null, callback: () => {} },
    ) => {
      try {
        const res = await AggregationUserApi.destroyAggregationUser(id)
        if (res.data.status === 'success') {
          const { data } = res.data.data

          const aggIdx = aggregationsData.value.findIndex(ag => ag.attributes.id === Number(aggregationId))
          if (aggIdx < 0) return

          const updatedAggData = { ...aggregationsData.value[aggIdx] }
          const aggUserIdx = updatedAggData.attributes.aggregationUsers.data.findIndex(aggUser => aggUser.attributes.id === Number(id))
          if (aggUserIdx < 0) return

          updatedAggData.attributes.aggregationUsers.data.splice(aggUserIdx, 1)
          aggregationsData.value.splice(aggIdx, 1, updatedAggData)

          const updatedAvailableUsers = availableUsers.value[id] ? [...availableUsers.value[id]] : []
          const userIdx = updatedAvailableUsers.findIndex(user => user.attributes.id === Number(userId))
          if (userIdx < 0) return

          updatedAvailableUsers.splice(userIdx, 1, data)
          availableUsers.value = { ...availableUsers.value, [id]: updatedAvailableUsers }
        }
      } catch (error) {
        handleApiError(error, { $toast: vm.$toast })
      } finally {
        callback()
      }
    }

    const handleFetchAvailableUsers = async (id, callback = () => {}) => {
      try {
        const res = await AggregationApi.getAvailableUsers(id)
        if (res.data.status === 'success') {
          const { data } = res.data.data
          availableUsers.value = { ...availableUsers.value, [id]: data }
        }
      } catch (error) {
        handleApiError(error, { $toast: vm.$toast })
      } finally {
        callback()
      }
    }

    const enqueueAggregations = async type => {
      const data = {
        EodClosingUserAggregation: eodClosingUserAggregationsData.value,
        EodClosingClubAggregation: eodClosingClubAggregationsData.value,
        EodClosingTableAggregation: eodClosingTableAggregationsData.value,
      }[type]
      if (!data) return

      const promises = data
        .filter(agg => {
          const { id } = agg.attributes

          return jobStatuses.value[id] === null || jobStatuses.value[id] === 'failed'
        })
        .map(agg => enqueueAggregation(agg.attributes.id))
      await Promise.all(promises)
    }

    // ユーザー集計グループ用一括キュー投入メソッド
    const enqueueUserAggregations = () => enqueueAggregations('EodClosingUserAggregation')
    // クラブ集計グループ用一括キュー投入メソッド
    const enqueueClubAggregations = () => enqueueAggregations('EodClosingClubAggregation')
    // テーブル集計グループ用一括キュー投入メソッド
    const enqueueTableAggregations = () => enqueueAggregations('EodClosingTableAggregation')

    onMounted(async () => {
      // ユーザー別実績パネル（案1）: 都度フェッチなので画面マウント時のプリフェッチは行わない。
      // ユーザー名クリック時に fetchPerformanceForUser でフェッチされる。
      await getAggregations()
    })

    return {
      aggregations,
      eodClosingUserAggregationsMap,
      eodClosingClubAggregationsMap,
      eodClosingTableAggregationsMap,
      eodClosingUserAggregationsData,
      eodClosingClubAggregationsData,
      eodClosingTableAggregationsData,
      loadingStatuses,
      jobStatuses,
      jobErrorMessages,
      availableUsers,
      isAnyJobInProgress,
      isAnyJobMissing,
      isAllJobCompleted,
      isAllJobMissing,
      aggregationUsers,
      canEnqueueJobs,
      jobTimestamps,
      isLoading,

      showSkeletonLoader,
      aggregationResultsMap,

      isPerformanceLoading,
      refreshUserPerformanceSummaries,
      selectedUser,
      isPanelOpen,
      selectedUserSummary,
      openUserPanel,
      onTimecardSaved,

      showFormattedTimestamp,
      reloadAggregation,
      refreshAggregation,
      enqueueGenerateBusinessRuleResults,
      generateBusinessRuleResult,
      createEodClosingUserAggregation,
      destroyEodClosingUserAggregation,
      handleFetchAvailableUsers,
      enqueueUserAggregations,
      enqueueClubAggregations,
      enqueueTableAggregations,

      icons: {
        mdiSync,
        mdiReload,
      },
    }
  },
}
</script>
